<template>
  <Card
    :title="cardTitle"
  >
    <template v-slot:button>
      <Button variant="default" @clicked="goBack">
        <template v-slot:any>
        <span class="flex items-center gap-2">
          <i class="fas fa-chevron-left"></i>
          Back
        </span>
        </template>
      </Button>
    </template>
    <template v-slot:body>
      <div class="w-full">
        <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
          <li class="-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer ">
            <a class=" text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(1)" v-bind:class="{'text-blue-500 bg-white': openTab !== 1, 'text-white bg-blue-500': openTab === 1}">
              Videos
            </a>
          </li>
          <li class="-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer ">
            <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(2)" v-bind:class="{'text-blue-500 bg-white': openTab !== 2, 'text-white bg-blue-500': openTab === 2}">
              Playlists
            </a>
          </li>
        </ul>
        <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
          <div class="px-4 py-5 flex-auto">
            <div class="tab-content tab-space">
              <div v-bind:class="{'hidden': openTab !== 1, 'block': openTab === 1}" class="mx-400 overflow-y-auto">
                <TabVideos ref="tab-videos" v-if="channel" :channel="channel" ></TabVideos>
              </div>
              <div v-bind:class="{'hidden': openTab !== 2, 'block': openTab === 2}" class="mx-400 overflow-y-auto">
                <TabPlaylist v-if="channel" :channel="channel" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import Card from '@/components/Layout/Card';
import { Button } from '@/components/Layout/Form';
import TabVideos from '@/views/MissionsVideos/Channel/TabVideos';
import TabPlaylist from '@/views/MissionsVideos/Channel/TabPlaylist';

export default {
  name: 'ChannelDetailPage',
  data() {
    return {
      channelId: Number(this.$route.params.channelId),
      utc_offset: Math.floor(moment().utcOffset() / 60),
      channel: null,
      videoId: null,
      openTab: 1
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    this.channel = await this.requestDetailChannel({
      id: this.channelId,
    });
    await this.requestListCategoryVideos();
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isOps', 'isFinance']),
    cardTitle() {
      return `Channel "${ this.channel ? this.channel.name: ''}" Video List`;
    },
  },
  methods: {
    ...mapActions('MissionsVideosModule', ['requestDetailChannel',
      'requestListCategoryVideos']),
    ...mapActions('AppSettingModule', ['requestListCountry']),
    toggleTabs(tabNumber) {
      this.openTab = tabNumber;
    },
    goBack() {
      this.$router.push({
        name: 'ChannelListPage',
      });
    },
  },
  components: {
    Card,
    Button,
    TabVideos,
    TabPlaylist
  },
};
</script>



// WEBPACK FOOTER //
// src/views/MissionsVideos/Channel/ChannelDetail.vue